export default __webpack_public_path__ + "static/media/srisailamVisitSix.290eb88e.jpg";